// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 900;
  src: url('DMSans-Black.488392488fc1755c.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 800;
  src: url('DMSans-ExtraBold.a5b0ab310755ef77.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 700;
  src: url('DMSans-Bold.5d8f19212e66f41c.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 600;
  src: url('DMSans-SemiBold.ba81386aaa3f8bec.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 500;
  src: url('DMSans-Medium.6e411356edf4bc5d.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 400;
  src: url('DMSans-Regular.254fafcf32e78d93.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 300;
  src: url('DMSans-Light.195d851006084602.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 200;
  src: url('DMSans-ExtraLight.a1df2f9a2054461d.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 100;
  src: url('DMSans-Thin.a9d11007dfa31cfb.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: italic;
  font-weight: 900;
  src: url('DMSans-BlackItalic.6085069ea3ad7499.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: italic;
  font-weight: 800;
  src: url('DMSans-ExtraBoldItalic.43c17c588c612b92.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: italic;
  font-weight: 700;
  src: url('DMSans-BoldItalic.05455c47a70f72be.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: italic;
  font-weight: 600;
  src: url('DMSans-SemiBoldItalic.7afda8ff11873b51.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: italic;
  font-weight: 500;
  src: url('DMSans-MediumItalic.2f9b70a7382ac1bd.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: italic;
  font-weight: 400;
  src: url('DMSans-Italic.da827be69095140a.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: italic;
  font-weight: 300;
  src: url('DMSans-LightItalic.9ac218ec8d449389.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: italic;
  font-weight: 200;
  src: url('DMSans-ExtraLightItalic.201c8891fc6a2a4e.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: italic;
  font-weight: 100;
  src: url('DMSans-ThinItalic.65c007651b2972db.ttf');
}
/* Old palette
\$accent-btn: #DD7EB0;
\$dark-text: #303f71;
\$light-text: #fff;
\$inactive-text: #A3AED0;
\$accent-blue: #84D9FD;*/
@font-face {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 900;
  src: url('DMSans-Black.488392488fc1755c.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 800;
  src: url('DMSans-ExtraBold.a5b0ab310755ef77.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 700;
  src: url('DMSans-Bold.5d8f19212e66f41c.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 600;
  src: url('DMSans-SemiBold.ba81386aaa3f8bec.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 500;
  src: url('DMSans-Medium.6e411356edf4bc5d.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 400;
  src: url('DMSans-Regular.254fafcf32e78d93.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 300;
  src: url('DMSans-Light.195d851006084602.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 200;
  src: url('DMSans-ExtraLight.a1df2f9a2054461d.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 100;
  src: url('DMSans-Thin.a9d11007dfa31cfb.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: italic;
  font-weight: 900;
  src: url('DMSans-BlackItalic.6085069ea3ad7499.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: italic;
  font-weight: 800;
  src: url('DMSans-ExtraBoldItalic.43c17c588c612b92.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: italic;
  font-weight: 700;
  src: url('DMSans-BoldItalic.05455c47a70f72be.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: italic;
  font-weight: 600;
  src: url('DMSans-SemiBoldItalic.7afda8ff11873b51.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: italic;
  font-weight: 500;
  src: url('DMSans-MediumItalic.2f9b70a7382ac1bd.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: italic;
  font-weight: 400;
  src: url('DMSans-Italic.da827be69095140a.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: italic;
  font-weight: 300;
  src: url('DMSans-LightItalic.9ac218ec8d449389.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: italic;
  font-weight: 200;
  src: url('DMSans-ExtraLightItalic.201c8891fc6a2a4e.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: italic;
  font-weight: 100;
  src: url('DMSans-ThinItalic.65c007651b2972db.ttf');
}
/* Old palette
\$accent-btn: #DD7EB0;
\$dark-text: #303f71;
\$light-text: #fff;
\$inactive-text: #A3AED0;
\$accent-blue: #84D9FD;*/
.lb-button {
  font-family: "Dm Sans", sans-serif;
  font-size: 20px;
  font-weight: 500;
  font-style: normal;
}

.lb-button {
  display: flex;
  flex-direction: column;
}

.lb-button {
  justify-content: center;
  align-items: center;
}

/*
\$theme-darkGray: #7D7979;
\$theme-lightGray: #BDBDBD;
\$theme-peach: #FFF2E1;
\$theme-yellow: #FFBB64;
\$theme-orange: #FF9001;
\$theme-blue: #2A296F;
\$sub-header-theme: #95a5a6;*/
.internal-info-container {
  display: block;
  min-height: 100vh;
  margin-left: 15px;
  margin-right: 15px;
  justify-content: center;
  max-width: 100%;
  overflow: hidden;
}

.top-button-container {
  display: flex;
  flex-direction: row;
  justify-content: space-evenly;
}

.lb-button {
  border-radius: 15px;
  border: none;
  height: 48px;
  display: flex;
  flex-direction: row;
  margin-bottom: 10px;
  width: 225px;
  background: #3792BF;
}
.lb-button p {
  color: #fff;
  font-size: 16px;
  font-weight: 500;
}
.lb-button:hover {
  opacity: 0.8;
  cursor: pointer;
}

app-lb-sidebar {
  width: 100%;
  height: 100%;
}

app-lb-banner {
  margin-right: 10px;
}

app-lb-full-width-dropdown {
  margin-right: 10px;
}

app-lb-full-width-separator {
  margin-right: 10px;
}

app-lb-button-grid {
  margin-right: 10px;
}

app-lb-dashboard-overview {
  width: 100%;
}

.dropdown-content {
  margin-bottom: 20px;
  padding: 10px;
  justify-content: center;
  border-radius: 8px;
}

.lb-wrapper {
  width: 100%;
  height: 100%;
}

@media screen and (max-width: 767.7px) {
  .dropdown-content {
    width: -moz-fit-content;
    width: fit-content;
  }
}`, "",{"version":3,"sources":["webpack://./src/theme/fonts.scss","webpack://./src/app/lbarometer/lb-dashboard/lb-dashboard.component.scss","webpack://./src/theme/variables.scss","webpack://./src/theme/placeholders/_fonts.scss","webpack://./src/theme/mixins.scss","webpack://./src/theme/placeholders/_flexboxes.scss","webpack://./src/app/lbarometer/styles.scss"],"names":[],"mappings":"AAAA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,6CAAA;ACCF;ADEA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,iDAAA;ACAF;ADGA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,4CAAA;ACDF;ADIA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,gDAAA;ACFF;ADKA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,8CAAA;ACHF;ADMA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,+CAAA;ACJF;ADOA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,6CAAA;ACLF;ADQA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,kDAAA;ACNF;ADSA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,4CAAA;ACPF;ADUA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,mDAAA;ACRF;ADWA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,uDAAA;ACTF;ADYA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,kDAAA;ACVF;ADaA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,sDAAA;ACXF;ADcA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,oDAAA;ACZF;ADeA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,8CAAA;ACbF;ADgBA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,mDAAA;ACdF;ADiBA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,wDAAA;ACfF;ADkBA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,kDAAA;AChBF;ACpGA;;;;;uBAAA;AFPA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,6CAAA;ACmHF;ADhHA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,iDAAA;ACkHF;AD/GA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,4CAAA;ACiHF;AD9GA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,gDAAA;ACgHF;AD7GA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,8CAAA;AC+GF;AD5GA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,+CAAA;AC8GF;AD3GA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,6CAAA;AC6GF;AD1GA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,kDAAA;AC4GF;ADzGA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,4CAAA;AC2GF;ADxGA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,mDAAA;AC0GF;ADvGA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,uDAAA;ACyGF;ADtGA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,kDAAA;ACwGF;ADrGA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,sDAAA;ACuGF;ADpGA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,oDAAA;ACsGF;ADnGA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,8CAAA;ACqGF;ADlGA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,mDAAA;ACoGF;ADjGA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,wDAAA;ACmGF;ADhGA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,kDAAA;ACkGF;ACtNA;;;;;uBAAA;AC+BA;ECtBE,kCFXY;EEYZ,eDqB2C;ECpB3C,gBAXqF;EAYrF,kBALgB;AH2NlB;;AIxOA;EAC0B,aAAA;EACA,sBAAA;AJ2O1B;;AInOA;EAC0B,uBAAA;EACA,mBAAA;AJsO1B;;AKnPA;;;;;;;4BAAA;ALMA;EACE,cAAA;EACA,iBAAA;EACA,iBAAA;EACA,kBAAA;EACA,uBAAA;EACA,eAAA;EACA,gBAAA;AAwPF;;AArPA;EACE,aAAA;EACA,mBAAA;EACA,6BAAA;AAwPF;;AArPA;EAGE,mBAAA;EAIA,YAAA;EAEA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,YAAA;EAEA,mBCfQ;ADgQV;AA/OE;EACE,WCxBS;EDyBT,eAAA;EACA,gBAAA;AAiPJ;AA9OE;EACI,YAAA;EACA,eAAA;AAgPN;;AA3OA;EACE,WAAA;EACA,YAAA;AA8OF;;AA5OA;EACE,kBAAA;AA+OF;;AA5OA;EACE,kBAAA;AA+OF;;AA5OA;EACE,kBAAA;AA+OF;;AA5OA;EACE,kBAAA;AA+OF;;AA7OA;EACE,WAAA;AAgPF;;AA5OA;EACE,mBAAA;EACA,aAAA;EACA,uBAAA;EACA,kBAAA;AA+OF;;AA3OA;EACE,WAAA;EACA,YAAA;AA8OF;;AAzOA;EACE;IACE,uBAAA;IAAA,kBAAA;EA4OF;AACF","sourcesContent":["@font-face {\n  font-family: 'DM Sans';\n  font-style: normal;\n  font-weight: 900;\n  src: url('../assets/DM_Sans/static/DMSans-Black.ttf');\n}\n\n@font-face {\n  font-family: 'DM Sans';\n  font-style: normal;\n  font-weight: 800;\n  src: url('../assets/DM_Sans/static/DMSans-ExtraBold.ttf');\n}\n\n@font-face {\n  font-family: 'DM Sans';\n  font-style: normal;\n  font-weight: 700;\n  src: url('../assets/DM_Sans/static/DMSans-Bold.ttf');\n}\n\n@font-face {\n  font-family: 'DM Sans';\n  font-style: normal;\n  font-weight: 600;\n  src: url('../assets/DM_Sans/static/DMSans-SemiBold.ttf');\n}\n\n@font-face {\n  font-family: 'DM Sans';\n  font-style: normal;\n  font-weight: 500;\n  src: url('../assets/DM_Sans/static/DMSans-Medium.ttf');\n}\n\n@font-face {\n  font-family: 'DM Sans';\n  font-style: normal;\n  font-weight: 400;\n  src: url('../assets/DM_Sans/static/DMSans-Regular.ttf');\n}\n\n@font-face {\n  font-family: 'DM Sans';\n  font-style: normal;\n  font-weight: 300;\n  src: url('../assets/DM_Sans/static/DMSans-Light.ttf');\n}\n\n@font-face {\n  font-family: 'DM Sans';\n  font-style: normal;\n  font-weight: 200;\n  src: url('../assets/DM_Sans/static/DMSans-ExtraLight.ttf');\n}\n\n@font-face {\n  font-family: 'DM Sans';\n  font-style: normal;\n  font-weight: 100;\n  src: url('../assets/DM_Sans/static/DMSans-Thin.ttf');\n}\n\n@font-face {\n  font-family: 'DM Sans';\n  font-style: italic;\n  font-weight: 900;\n  src: url('../assets/DM_Sans/static/DMSans-BlackItalic.ttf');\n}\n\n@font-face {\n  font-family: 'DM Sans';\n  font-style: italic;\n  font-weight: 800;\n  src: url('../assets/DM_Sans/static/DMSans-ExtraBoldItalic.ttf');\n}\n\n@font-face {\n  font-family: 'DM Sans';\n  font-style: italic;\n  font-weight: 700;\n  src: url('../assets/DM_Sans/static/DMSans-BoldItalic.ttf');\n}\n\n@font-face {\n  font-family: 'DM Sans';\n  font-style: italic;\n  font-weight: 600;\n  src: url('../assets/DM_Sans/static/DMSans-SemiBoldItalic.ttf');\n}\n\n@font-face {\n  font-family: 'DM Sans';\n  font-style: italic;\n  font-weight: 500;\n  src: url('../assets/DM_Sans/static/DMSans-MediumItalic.ttf');\n}\n\n@font-face {\n  font-family: 'DM Sans';\n  font-style: italic;\n  font-weight: 400;\n  src: url('../assets/DM_Sans/static/DMSans-Italic.ttf');\n}\n\n@font-face {\n  font-family: 'DM Sans';\n  font-style: italic;\n  font-weight: 300;\n  src: url('../assets/DM_Sans/static/DMSans-LightItalic.ttf');\n}\n\n@font-face {\n  font-family: 'DM Sans';\n  font-style: italic;\n  font-weight: 200;\n  src: url('../assets/DM_Sans/static/DMSans-ExtraLightItalic.ttf');\n}\n\n@font-face {\n  font-family: 'DM Sans';\n  font-style: italic;\n  font-weight: 100;\n  src: url('../assets/DM_Sans/static/DMSans-ThinItalic.ttf');\n}\n\n","@import 'variables';\n@import 'placeholders/fonts';\n@import 'placeholders/flexboxes';\n@import 'variables/breakpoints';\n@import '../styles.scss';\n\n.internal-info-container {\n  display: block;\n  min-height: 100vh;\n  margin-left: 15px;\n  margin-right: 15px;\n  justify-content: center;\n  max-width: 100%;\n  overflow: hidden;\n}\n\n.top-button-container {\n  display:flex;\n  flex-direction:row;\n  justify-content: space-evenly;\n}\n\n.lb-button {\n  \n\n  border-radius: 15px;\n  @extend %font-20px-medium;\n  @extend %flex-column;\n  @extend %flex-jCenter-aCenter;\n  border: none;\n\n  height: 48px;\n  display: flex;\n  flex-direction: row;\n  margin-bottom: 10px;\n  width:225px;\n  \n  background: $theme-1;\n\n  p {\n    color: $light-text;\n    font-size: 16px;\n    font-weight: 500;\n  }\n\n  &:hover {\n      opacity: 0.8;\n      cursor: pointer;\n  }\n\n}\n\napp-lb-sidebar {\n  width: 100%;\n  height: 100%;\n}\napp-lb-banner {\n  margin-right: 10px;\n}\n\napp-lb-full-width-dropdown {\n  margin-right: 10px;\n}\n\napp-lb-full-width-separator {\n  margin-right: 10px;\n}\n\napp-lb-button-grid {\n  margin-right: 10px;\n }\napp-lb-dashboard-overview {\n  width: 100%;\n}\n\n\n.dropdown-content {\n  margin-bottom: 20px;\n  padding: 10px;\n  justify-content: center;\n  border-radius: 8px;\n}\n\n\n.lb-wrapper {\n  width: 100%;\n  height: 100%;\n}\n\n\n// 767.7px;\n@media screen and (max-width: $breakpoint-sm-max) {\n  .dropdown-content {\n    width: fit-content;\n  }\n}\n\n//// 1023.7px and 768px;\n//@media screen and (max-width: $breakpoint-md-max) and (min-width: $breakpoint-md-min) {\n//\n//}\n//\n//// 1199.7px and 1024px;\n//@media screen and (max-width: $breakpoint-lg-max) and (min-width: $breakpoint-lg-min) {\n//\n//}\n//\n//// 1199.7px and 1199.7px\n//@media screen and (max-width: $breakpoint-lg-max) and (min-width: $breakpoint-lg-max) {\n//\n//}\n//\n//// 2559.7px and 1200px;\n//@media screen and (max-width: $breakpoint-xxl-max) and (min-width: $breakpoint-xl-min) {\n//\n//}\n//\n////  2560px;\n//@media screen and (min-width: $breakpoint-xxxl-min) {\n//\n//}\n","@import \"fonts\";\n\n// this file is more for variables that cannot be used in the theme\n// many of these should be migrated after the material theme has been configured.\n\n$font-family: \"Dm Sans\", sans-serif;\n\n/* Old palette\n$accent-btn: #DD7EB0;\n$dark-text: #303f71;\n$light-text: #fff;\n$inactive-text: #A3AED0;\n$accent-blue: #84D9FD;*/\n\n$accent-btn: #0CAD99;\n$dark-text: #1B3E78;\n$light-text: #fff;\n$inactive-text: #A3AED0;\n$accent-blue: #3792BF;\n\n$theme-main: #1B3E78;\n$theme-contrast: #0CAD99;\n$theme-1: #3792BF;\n$theme-2: #AACCFF;\n$theme-3: #BDBDBD;\n$theme-4: #7D7979;\n$theme-5: #787c95;\n\n$app-background: #F4F7FE;\n\n$rDNA-success: #00B300;\n$rDNA-alert: #FF0000;\n$rDNA-neutral: #FFBF00;\n","@import '../mixins';\n\n/////////////////////////////////////\n//   Extra Bold Font Placeholders  //\n/////////////////////////////////////\n\n%font-16px-extra-bold { @include format-font(16px, 'extra bold'); }\n\n/////////////////////////////////////\n//     Bold Font Placeholders     //\n/////////////////////////////////////\n\n%font-52px-bold       { @include format-font(52px, 'bold'); }\n%font-48px-bold       { @include format-font(48px, 'bold'); }\n%font-34px-bold       { @include format-font(34px, 'bold'); }\n%font-32px-bold       { @include format-font(32px, 'bold'); }\n%font-28px-bold       { @include format-font(28px, 'bold'); }\n%font-24px-bold       { @include format-font(24px, 'bold'); }\n%font-20px-bold       { @include format-font(20px, 'bold'); }\n%font-18px-bold       { @include format-font(18px, 'bold'); }\n%font-16px-bold       { @include format-font(16px, 'bold'); }\n%font-14px-bold       { @include format-font(14px, 'bold'); }\n%font-12px-bold       { @include format-font(12px, 'bold'); }\n\n\n/////////////////////////////////////\n//   Semi-Bold Font Placeholders   //\n/////////////////////////////////////\n\n%font-24px-semi       { @include format-font(24px, 'semi-bold'); }\n%font-20px-semi       { @include format-font(20px, 'semi-bold'); }\n\n\n/////////////////////////////////////\n//     Medium Font Placeholders    //\n/////////////////////////////////////\n\n%font-30px-medium     { @include format-font(30px, 'medium'); }\n%font-20px-medium     { @include format-font(20px, 'medium'); }\n%font-18px-medium     { @include format-font(18px, 'medium'); }\n%font-16px-medium     { @include format-font(16px, 'medium'); }\n%font-14px-medium     { @include format-font(14px, 'medium'); }\n%font-12px-medium     { @include format-font(12px, 'medium'); }\n%font-10px-medium     { @include format-font(10px, 'medium'); }\n\n/////////////////////////////////////\n//    Normal Font Placeholders     //\n/////////////////////////////////////\n\n%font-18px-normal     { @include format-font(18px); }\n%font-16px-normal     { @include format-font(16px); }\n%font-14px-normal     { @include format-font(14px); }\n%font-12px-normal     { @include format-font(12px); }\n","@import 'variables';\n\n@mixin format-font($size, $weight: 500, $style: 'normal' ) {\n  @if ( $weight == 'thin' or $weight == 'Thin' ) { $weight: 100; }\n  @else if ( $weight == 'extra light' or $weight == 'Extra light' or $weight == 'extra Light' or $weight == 'Extra Light' or  $weight == 'el') { $weight: 200; }\n  @else if ( $weight == 'light' or $weight == 'Light'  or $weight == 'l') { $weight: 300; }\n  @else if ( $weight == 'normal' or $weight == 'Normal'  or $weight == 'n') { $weight: 400; }\n  @else if ( $weight == 'medium' or $weight == 'Medium'  or $weight == 'm') { $weight: 500; }\n  @else if ( $weight == 'semi-bold' or $weight == 'Semi-bold' or $weight == 'semi-Bold' or $weight == 'Semi-Bold' or $weight == 'sb' ) { $weight: 600; }\n  @else if ( $weight == 'bold' or $weight == 'Bold' or $weight == 'b' ) { $weight: 700; }\n  @else if ( $weight == 'extra bold' or $weight == 'Extra bold' or $weight == 'extra Bold' or $weight == 'Extra Bold' or $weight == 'eb' ) { $weight: 800; }\n  @else if ( $weight == 'black' or $weight == 'Black' or $weight == 'blk') { $weight: 900; }\n\n  @if ( $style == 'Italic' or $style == 'i' ) { $style: italic; }\n  @else { $style: normal; }\n\n  font-family: $font-family;\n  font-size: $size;\n  font-weight: $weight;\n  font-style: $style;\n}\n","\n%flex-column            {\n                          display: flex;\n                          flex-direction: column;\n                        }\n\n%flex-row               {\n                          display: flex;\n                          flex-direction: row;\n                        }\n\n%flex-jCenter-aCenter   {\n                          justify-content: center;\n                          align-items: center;\n                        }\n\n%flex-jCenter-aStart    {\n                          justify-content: center;\n                          align-items: flex-start;\n                        }\n\n%flex-jCenter-aEnd      {\n                          justify-content: center;\n                          align-items: flex-end;\n                        }\n\n%flex-jStart-aCenter    {\n                          justify-content: flex-start;\n                          align-items: center;\n                        }\n\n%flex-jStart-aStart     {\n                          justify-content: flex-start;\n                          align-items: flex-start;\n                        }\n\n%flex-jStart-aEnd       {\n                          justify-content: flex-start;\n                          align-items: flex-end;\n                        }\n\n%flex-jEnd-aCenter      {\n                          justify-content: flex-end;\n                          align-items: center;\n                        }\n\n%flex-jEnd-aStart       {\n                          justify-content: flex-end;\n                          align-items: flex-start;\n                        }\n\n%flex-jEnd-aEnd         {\n                          justify-content: flex-end;\n                          align-items: flex-end;\n                        }\n\n","/*\n$theme-darkGray: #7D7979;\n$theme-lightGray: #BDBDBD;\n$theme-peach: #FFF2E1;\n$theme-yellow: #FFBB64;\n$theme-orange: #FF9001;\n$theme-blue: #2A296F;\n$sub-header-theme: #95a5a6;*/\n\n//----\n\n$theme-primary: #3792BF; \n$theme-secondary: #1B3E78; \n$theme-color3: #AACCFF; \n$theme-color4: #BDBDBD; \n$theme-color5: #7D7979; \n$theme-accent: #0CAD99; \n\n$text-gray:#787c95;"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
